import React from 'react';
import moment from 'moment';
import classnames from 'classnames';

import { SingleDatePicker } from 'react-dates';
import Box from 'grommet/components/Box';

const initialVisibleMonth = (season, date) => {
  const year = new Date().getFullYear();
  if (date) return date;

  switch (season) {
    case 'fall': {
      return moment().month('October').year(year - 1)
    }
    case 'spring': {
      return moment().month('April').year(year);
    }
    case 'in_season':
      return moment().month('May').year(year);

    default:
      return moment();
  }
}

export default function({
  label,
  name,
  value,
  error,
  season,
  ...rest,
}) {
  const classList = classnames(
    'datepicker-wrapper grommetux-form-field grommetux-form-field--size-medium',
    { 'grommetux-form-field--error': !!error }
  );

  return (
    <Box
      className={classList}
      style={{ zIndex: rest.focused ? 2 : 'inherit' }}
    >
      <Box direction="row" justify="between">
        <label className="grommetux-form-field__label">{label}</label>
        <span display-if={error} className="grommetux-form-field__error">{error}</span>
      </Box>
      <SingleDatePicker
        isOutsideRange={() => false}
        initialVisibleMonth={() => initialVisibleMonth(season, value)}
        numberOfMonths={1}
        id={name}
        date={value}
        {...rest}
      />
    </Box>
  );
}



// WEBPACK FOOTER //
// ./src/elements/Datepicker/index.js